import FormError from 'components/form-error/form-error.component';
import { useSpreedlyGlobalErrors } from './spreedly-global-errors.hooks';

const SpreedlyGlobalErrors = () => {
  const formErrors = useSpreedlyGlobalErrors();

  return formErrors.map(error => {
    return (
      <FormError
        key={error.message}
        aria-live="assertive"
        errorMessage={error.message}
        sx={{ marginTop: '0 !important' }}
      />
    );
  });
};

export default SpreedlyGlobalErrors;
